import Molde from "./MoldeTransporte";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function TransporteOllanta_Cusco() {
  return (
    <>
      <Molde
        image={"/images/ollanta_cusco_t.png"}
        title={"TRANSPORTE OLLANTAYTAMBO - CUSCO"}
        subtitle={"(Todo el día)"}
        description={
          "Este servicio de transporte privado ofrece un traslado cómodo y directo desde Ollantaytambo hasta Cusco, proporcionando un viaje sin complicaciones entre estos dos puntos importantes. Ollantaytambo, conocido por su relevancia arqueológica y como el principal punto de partida de trenes hacia Machu Picchu, está ubicado aproximadamente a 1.5 a 2 horas de Cusco. Ya sea que regreses de tu visita a Machu Picchu o que estés explorando el Valle Sagrado, este servicio de transporte garantiza un traslado cómodo, conveniente y puntual de vuelta a Cusco."
        }
        
        //linkForm={"/reservar/citytour-dia"}
        //tipoprecio={"Precio por persona"}
        //monto={"US$ 11.00"}
        //moneda={"DOLARES"}

        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="RECOJO"
              lugar="OLLANTAYTAMBO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                <div className="p-8">
                  <p className="text-justify text-primary-800"><strong>Punto de Recogida:</strong> El conductor se reunirá con los viajeros en el punto de recogida acordado en Ollantaytambo, que puede ser en un hotel, la estación de tren de Ollantaytambo u otro lugar dentro del pueblo. El conductor llevará un cartel con el nombre de la reserva o el nombre del viajero.</p>
                  <p className="text-justify text-primary-800" ><strong>Hora de Recogida:</strong> El servicio está disponible a cualquier hora necesaria para tu viaje de regreso a Cusco. Se recomienda coordinar la hora de recogida con anticipación para garantizar que el conductor esté disponible a la hora exacta.</p>
                  <p className="text-justify text-primary-800"><strong>Vehículo:</strong> El servicio se realiza en vehículos cómodos y bien equipados, como coches privados, vans o minibuses, dependiendo del número de pasajeros. Todos los vehículos son modernos y cuentan con aire acondicionado para mayor comodidad.</p>
                </div>
                <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-home.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-1.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-3.png`} alt="" />
                    <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/valle-sagrado-4.png`} alt="" />
                </div>
              </div>
            </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="TRAYECTO"
              lugar="A CUSCO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                <div className="p-8">
                  <p className="text-justify text-primary-800"><strong>Duración:</strong> El trayecto desde Ollantaytambo hasta Cusco toma aproximadamente entre 1.5 y 2 horas, dependiendo del tráfico y las condiciones de la carretera.</p>
                  <p className="text-justify text-primary-800" ><strong>Ruta:</strong> El viaje tomará la carretera principal desde Ollantaytambo hacia Cusco, pasando por Urubamba y otros pintorescos pueblos en el Valle Sagrado. El trayecto ofrece hermosas vistas de las montañas y valles del Valle Sagrado, haciendo de este un viaje visualmente agradable.</p>
                  <p className="text-justify text-primary-800"><strong>Vistas panorámicas:</strong> Los viajeros podrán disfrutar de las impresionantes paisajes andinos a lo largo del camino, incluidos los valles, ríos y pueblos tradicionales andinos.</p>
                </div>
                <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_1.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_2.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_3.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_4.png`} alt="" />
                </div>
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="LLEGADA"
              lugar="CUSCO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-2 p-2 lg:gap-4 gap-2 border-2 border-primary-800 rounded-lg mt-2">
                <div className="p-8">
                  <p className="text-justify text-primary-800"><strong>Punto de Llegada:</strong> El servicio finalizará en el punto de llegada acordado en Cusco, que puede ser en un hotel, el centro de la ciudad o cualquier otro lugar dentro de Cusco, según las preferencias del viajero.</p>
                  <p className="text-justify text-primary-800" ><strong>Hora de Llegada:</strong> La hora de llegada depende de la hora de recogida, pero el viaje de regreso generalmente toma entre 1.5 y 2 horas.</p>
                </div>
                <div className="m-8 grid grid-cols-1 lg:grid-cols-2 gap-2">
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_5.png`} alt="" />
                  <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/transporte_6.png`} alt="" />
                </div>
              </div>
            </div>
          </>
        }
        

        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            <p className="text-primary-800 font-light">Guia profesional</p>
            <p className="text-primary-800 font-light">Asistencia permanente</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Ingreso a koricancha </p>
            <p className="text-primary-800 font-light">Boleto turistico </p>
            <p className="text-primary-800 font-light">Gastos extra</p>
          </>
        }
        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/auto_t.svg`}
              title={"Vehiculo"}
              desc={"Auto moderno"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"VIP"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"1.5 a 2 Horas"}
            />
            {/*
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Cultural"}
            />*/}
          </>
        }
        
        TourRecomienda={
          <>
            <CardRecomienda
              img={"/images/montania_colores.png"}
              title={"MONTAÑA 7 COLORES"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
              img={"/images/valle-vip-5.png"}
              title={"VALLE VIP"}
              puntuacion={"5"}
              link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
              img={"/images/laguna_huamantay.png"}
              title={"LAGUNA HUAMANTAY"}
              puntuacion={"5"}
              link={'/tour-tradicional/laguna-huamantay'}
            />
            <CardRecomienda
              img={"/images/maras-moray-4.png"}
              title={"MARAS-MORAY"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/maras-moray'}
            />
          </>
        }
      />
    </>
  );
}
